export const courses = [
  {
    id: 1,
    title: "DATA SCIENCE, AI, AND MACHINE LEARNING USING PYTHON",
    type: "PROJECT-BASED",
    description: "Master data science, artificial intelligence, and machine learning concepts through hands-on Python projects. Learn to build predictive models, analyze data, and implement AI solutions.",
    duration: "2-6 months",
    price: 599,
    features: [
      "Python programming fundamentals",
      "Data analysis and visualization",
      "Machine Learning algorithms",
      "Deep Learning basics",
      "Real-world AI projects",
      "Certificate upon completion"
    ]
  },
  {
    id: 2,
    title: "PYTHON AND ITS APPLICATIONS",
    type: "PROJECT-BASED",
    description: "Comprehensive Python course covering core concepts and practical applications. Build real-world projects and gain proficiency in Python programming.",
    duration: "2-6 months",
    price: 599,
    features: [
      "Python basics to advanced",
      "Object-oriented programming",
      "Web scraping and automation",
      "Database integration",
      "API development",
      "Certificate upon completion"
    ]
  },
  {
    id: 3,
    title: "FULL STACK WEB DEVELOPMENT USING MERN STACK",
    type: "PROJECT-BASED",
    description: "Learn to build modern web applications using MongoDB, Express.js, React, and Node.js. Create full-stack applications from scratch.",
    duration: "2-6 months",
    price: 599,
    features: [
      "MongoDB database design",
      "Express.js backend development",
      "React frontend development",
      "Node.js server-side programming",
      "RESTful API creation",
      "Certificate upon completion"
    ]
  },
  {
    id: 4,
    title: "CYBER SECURITY AND ETHICAL HACKING",
    type: "PROJECT-BASED",
    description: "Learn ethical hacking techniques and cybersecurity fundamentals. Understand security vulnerabilities and how to protect systems.",
    duration: "2-6 months",
    price: 599,
    features: [
      "Network security fundamentals",
      "Penetration testing",
      "Security tools and techniques",
      "Vulnerability assessment",
      "Ethical hacking practices",
      "Certificate upon completion"
    ]
  },
  {
    id: 5,
    title: "DIGITAL MARKETING",
    type: "PROJECT-BASED",
    description: "Master digital marketing strategies including SEO, social media marketing, content marketing, and analytics through practical projects.",
    duration: "2-6 months",
    price: 599,
    features: [
      "SEO optimization",
      "Social media marketing",
      "Content marketing strategies",
      "Google Analytics",
      "Email marketing campaigns",
      "Certificate upon completion"
    ]
  },
  {
    id: 6,
    title: "ADVANCED EXCEL",
    type: "PROJECT-BASED",
    description: "Become an Excel expert with advanced functions, data analysis, automation, and visualization techniques. Perfect for business professionals.",
    duration: "2-6 months",
    price: 599,
    features: [
      "Advanced formulas and functions",
      "Pivot tables and charts",
      "Data analysis and modeling",
      "Macros and VBA basics",
      "Dashboard creation",
      "Certificate upon completion"
    ]
  },
  {
    id: 7,
    title: "APP DEVELOPMENT (KOTLIN)",
    type: "PROJECT-BASED",
    description: "Learn Android app development using Kotlin. Build modern, feature-rich mobile applications with industry best practices and hands-on projects.",
    duration: "2-6 months",
    price: 599,
    features: [
      "Kotlin programming fundamentals",
      "Android Studio and development tools",
      "UI/UX design for mobile apps",
      "Database integration with Room",
      "API integration and networking",
      "Certificate upon completion"
    ]
  }
];
